import {
  View,
  Text,
  ScrollView,
  RefreshControl,
  Dimensions,
  PixelRatio,
  StyleSheet,
  Modal,
  Platform,
} from "react-native";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Header from "./Header";
import BodyHome from "./BodyHome";
import TopHeader from "./TopHeader";

import NetInfo from "@react-native-community/netinfo";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import { useQuery } from "@tanstack/react-query";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import CameraIcon from "../../icons/CameraIcon";
import PhotoUploadIcon from "../../icons/PhotoUploadIcon";
import PostingPicturePage from "./PostingPicturePage";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import useAuth from "../../hooks/useAuth";
import { SafeAreaView } from "react-native-safe-area-context";
import {
  connectSavedPrinter,
  startPrinterWorker,
  stopPrinterWorker,
} from "../../services/printerService";
import { initOrderQueue } from "../../services/orderQueueService";
import AcknowledgeRedemptionScreen from "../bussiness/AcknowledgeRedemptionScreen";
import { useFocusEffect } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

export default function HomeScreen() {
  const [refreshing, setRefreshing] = useState(false);
  const [fabOpen, setFabOpen] = useState(false);
  const [showPostingPicture, setShowPostingPicture] = useState(false);
  const [displayLimit, setDisplayLimit] = useState(10); // Number of items to load per batch

  const axiosPrivate = useAxiosPrivate();
  const { hasUnacknowledgedRedemption, sub } = useAuth();
  console.log("hasUnacknowledgedRedemption55", hasUnacknowledgedRedemption);

  //console.log()

  // useEffect(() => {
  //   connectSavedPrinter(); //FOR MERCHANTS
  // }, []);

  useEffect(() => {
    async function initializeMerchantPrinter() {
      try {
        // Create SQLite tables first
        if (Platform.OS === "android") {
          initOrderQueue();
        }

        // Connect saved Bluetooth printer
        await connectSavedPrinter();

        // Start worker only after database is ready
        if (Platform.OS === "android") {
          startPrinterWorker();
        }
      } catch (error) {
        console.log("Merchant printer initialization error:", error);
      }
    }

    initializeMerchantPrinter();

    return () => {
      if (Platform.OS === "android") {
        stopPrinterWorker();
      }
    };
  }, []);

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      if (!state.isConnected) {
        Toast.show({
          type: "error",
          text2: "No Internet, check your network connection.",
        });
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Check for the table notice stored during Google auth
    // const tableNotice = sessionStorage.getItem("table_join_notice");
    const tableNotice = globalThis.sessionStorage?.getItem("table_join_notice") ?? null;

    if (tableNotice) {
      // Determine toast type dynamically based on success vs error messages
      const isError =
        tableNotice.includes("invalid") ||
        tableNotice.includes("not active") ||
        tableNotice.includes("capacity") ||
        tableNotice.includes("already joined");

      Toast.show({
        type: isError ? "error" : "success",
        text1: isError ? "Table Join Failed" : "Table Joined",
        text2: tableNotice,
      });

      // if (Platform.OS === "web" && typeof sessionStorage !== "undefined") {
      //   // Clear it immediately so it only shows once
      //   sessionStorage.removeItem("table_join_notice");
      // }
      globalThis.sessionStorage?.removeItem("table_join_notice");
    }
  }, []);

  // useEffect(() => {
  //   const calculatePullCredFromTrend = async () => {
  //     try {
  //       const response = await axiosPrivate.post("/pullCredByTrend/pullCredByTrend");
  //       // ////console.log("Trending PullCRED calculation successful:", response.data);
  //     } catch (err) {
  //       // //console.error("Error calculating trending PullCRED:", err);
  //     }
  //   };

  //   calculatePullCredFromTrend();
  // }, []);

  const handleFabPress = () => {
    ////console.log("FAB Pressed");
    // Navigate or show modal etc.
  };
  const handleLoadMore = () => {
    setDisplayLimit((prev) => prev + 10);
  };

  const toggleFab = () => {
    setFabOpen((prev) => !prev);
  };

  // 1. Updated API fetching function
  const fetchRecentUserTables = async () => {
    // Endpoint to fetch dynamic user tables
    const response = await axiosPrivate.get(`/veryRecentVirtualTables/veryRecentVirtualTables`);
    //console.log("recentTablesrecentTables", response.data.data);

    return response.data.data || []; // Expected to return an array of table objects
  };

  // 2. Updated useQuery implementation
  const {
    data: recentTables,
    isLoading: isLoadingTables,
    refetch,
  } = useQuery({
    // Include userId in queryKey so it refetches/caches correctly per user
    queryKey: ["recentUserTables", sub],
    queryFn: fetchRecentUserTables, // No need to pass it here anymore!
    enabled: !!sub,

    // Reduce staleTime from 1 hour to 15-30 seconds so users see newly created tables quickly
    // staleTime: 1000 * 30,
    // refetchInterval: 1000 * 60, // Optional: Poll every 60 seconds to clean up expired >1hr tables
    refetchInterval: 8000, // refresh every 8 second
    refetchIntervalInBackground: true,
    staleTime: 5000,
  });

  // 4. Add the useFocusEffect hook here
  useFocusEffect(
    useCallback(() => {
      refetch(); // Instantly fetch fresh table data when screen comes into focus
    }, [refetch]),
  );

  const yourRecentTablesArray = recentTables;

  // // 3. Client-side safeguard filter (Ensures strict 1-hour limits on the UI)
  // const yourRecentTablesArray = useMemo(() => {
  //   if (!recentTables || !Array.isArray(recentTables)) return [];

  //   //const oneHourAgo = Date.now() - 60 * 60 * 1000;
  //   const twentyFourHoursAgo = Date.now() - 24 * 60 * 60 * 1000;

  //   return recentTables.filter((table) => {
  //     const creationTime = new Date(table.createdAt).getTime();
  //     return creationTime >= twentyFourHoursAgo;
  //   });
  // }, [recentTables]);

  // const {
  //   data: higherTablesLocal,
  //   isLoading: loadingHairTablesLocal,
  //   refetch: refetchHigherTablesLocal,
  //   error: errorHigherTablesLocal,
  // } = useQuery({
  //   queryKey: ["higherTablesLocal"],
  //   queryFn: async () => {
  //     ////console.log(" Running query for higherTablesLocal");
  //     // const response = await axiosPrivate.get("/higherTablesLocal/higherTablesLocal");
  //     // ////console.log(" Data received:", response.data);
  //     // return response.data;
  //   },
  //   onError: (error) => {
  //     Toast.show({
  //       type: "error",
  //       text1: "Error Fetching Higher Tables",
  //       text2: error.message || "Something went wrong!",
  //     });
  //   },
  // });

  // const {
  //   data: topLocalCelebratories,
  //   isLoading: loadingCelebratoriesLocal,
  //   refetch: refetchTopLocalCelebratories,
  //   error: errorCelebratoriesLocal,
  // } = useQuery({
  //   queryKey: ["topLocalCelebratories"],
  //   queryFn: async () => {
  //     ////console.log(" Running query for topLocalCelebratories");
  //     // const response = await axiosPrivate.get("/topLocalCelebratories/topLocalCelebratories");
  //     // ////console.log("topLocalCelebratories Data received:", response.data);
  //     // return response.data;
  //   },
  //   onError: (error) => {
  //     Toast.show({
  //       type: "error",
  //       text1: "Error Fetching Higher Tables",
  //       text2: error.message || "Something went wrong!",
  //     });
  //   },
  // });

  // const onRefresh = async () => {
  //   setRefreshing(true);
  //   try {
  //     await Promise.all([refetchHigherTablesLocal(), refetchTopLocalCelebratories()]);
  //   } catch (error) {
  //     //console.error('Refresh Error:', error);
  //   } finally {
  //     setRefreshing(false);
  //   }
  // };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "white" }}>
      <TopHeader headerText={"Meeza"} />
      <ScrollView
        // refreshControl={
        //   <RefreshControl
        //     refreshing={refreshing}
        //     onRefresh={onRefresh}
        //     colors={[Colours.PRIMARY]}
        //   />
        // }
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 200,
          backgroundColor: Colours.LIGHTEST,
        }}
        onScroll={({ nativeEvent }) => {
          const isCloseToBottom =
            nativeEvent.layoutMeasurement.height + nativeEvent.contentOffset.y >=
            nativeEvent.contentSize.height - 100;
          if (isCloseToBottom) {
            handleLoadMore();
          }
        }}
        scrollEventThrottle={400}
      >
        {/* Header */}
        <Header
          yourRecentTablesArray={yourRecentTablesArray || []}
          isLoadingTables={isLoadingTables || false}
        />
        <BodyHome
          // higherTablesLocal={higherTablesLocal || []}
          // topLocalCelebratories={topLocalCelebratories || []}
          // isLoading={loadingHairTablesLocal || loadingCelebratoriesLocal || []}
          yourRecentTablesArray={yourRecentTablesArray || []}
          isLoadingTables={isLoadingTables || false}
          displayLimit={displayLimit}
        />
      </ScrollView>

      <Toast config={toastConfig} />
      {/* 
      <TouchableOpacity
        style={styles.fab}
        onPress={() => {
          if (!isBlockedAccess) {
            setShowPostingPicture(true);
          }
        }}
      >
        <Text style={styles.fabText}>
          <CameraIcon color="white" height={dynamicSize(30)} width={dynamicSize(30)} />
        </Text>
      </TouchableOpacity>
      {fabOpen && (
        <TouchableOpacity
          style={styles.overlay}
          activeOpacity={1}
          onPress={() => setFabOpen(false)}
        />
      )}
      {fabOpen && (
        <>
          <TouchableOpacity
            style={[styles.subFab, { bottom: dynamicSpacing(100) }]}
            onPress={() => {
              setFabOpen(false);
            }}
          >
            <Text style={styles.subFabText}>
              <CameraIcon color="white" height={dynamicSize(30)} width={dynamicSize(30)} />
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.subFab1, { bottom: dynamicSpacing(170) }]}
            onPress={() => {
              setFabOpen(false);
              setShowPostingPicture(true);
            }}
          >
            <Text style={styles.subFabText}>
              <PhotoUploadIcon color="white" height={dynamicSize(30)} width={dynamicSize(30)} />
            </Text>
          </TouchableOpacity>
        </>
      )} */}

      {/* ── ACKNOWLEDGEMENT FULL SCREEN MODAL ── */}
      <AcknowledgeRedemptionScreen visible={hasUnacknowledgedRedemption} />

      <Modal
        animationType="slide"
        visible={showPostingPicture}
        onRequestClose={() => setShowPostingPicture(false)}
      >
        <TopHeaderComponent
          headerText={"Photo Selection"}
          hideScreen={() => setShowPostingPicture(false)}
        />
        <View style={{ backgroundColor: Colours.LIGHTEST }}>
          <PostingPicturePage setShowPostingPicture={setShowPostingPicture} />
        </View>
      </Modal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 8,
  },
  fab: {
    position: "absolute",
    right: dynamicSpacing(20),
    bottom: dynamicSpacing(30), // Ensures it sits above the bottom tab
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(30),
    backgroundColor: Colours.PRIMARY,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 10, // Ensures it floats above other content
  },
  fabText: {
    color: "#fff",
    fontSize: dynamicFontSize(30),
    fontWeight: "bold",
  },
  subFab1: {
    position: "absolute",
    right: dynamicSpacing(20),
    width: dynamicSize(50),
    height: dynamicSize(50),
    borderRadius: dynamicSize(25),
    backgroundColor: Colours.DARKGRAY,
    justifyContent: "center",
    alignItems: "center",
    elevation: 4,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    zIndex: 9,
  },
  subFab: {
    position: "absolute",
    right: dynamicSpacing(20),
    width: dynamicSize(50),
    height: dynamicSize(50),
    borderRadius: dynamicSize(25),
    backgroundColor: Colours.PRIMARY,
    justifyContent: "center",
    alignItems: "center",
    elevation: 4,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    zIndex: 9,
  },
  subFabText: {
    fontSize: dynamicFontSize(20),
    color: "#fff",
  },
});
